import { loadingView, unloadingView } from '../../../loader.js';

import yml_boxer_homme from './yml/boxer_homme.yml'
import yml_boxer_femme from './yml/boxer_femme.yml'
import yml_boxer_garcon from './yml/boxer_garcon.yml'
import yml_boxer_fille from './yml/boxer_fille.yml'
import yml_boxer_long_homme from './yml/boxer_long_homme.yml'
import yml_shorty_femme from './yml/shorty_femme.yml'
import yml_tourdecou_adulte from './yml/tourdecou_adulte_47x42.yml'
import yml_tourdecou_enfant from './yml/tourdecou_enfant_39x28.yml'
import yml_bandana_adulte from './yml/bandana_adulte_50x50.yml'

import yml_tapis_souris_rectangle from './yml/tapis_souris_rectangle.yml'
import yml_tapis_souris_rond from './yml/tapis_souris_rond.yml'
import yml_brassiere_fitness from './yml/brassiere_fitness.yml'
import boule_noel_or from './yml/boule_noel_argent.yml'
import boule_noel_argent from './yml/boule_noel_argent.yml'
import boule_noel_rouge from './yml/boule_noel_rouge.yml'
import boule_noel_vert from './yml/boule_noel_vert.yml'
import boule_noel_multi from './yml/boule_noel_multi.yml'
import housse_coussin_40x40 from './yml/housse_coussin_40x40.yml'
import housse_coussin_40x60 from './yml/housse_coussin_40x60.yml'
import plaque_alu_20x25 from './yml/plaque_alu_20x25.yml'
import plaque_alu_28x40 from './yml/plaque_alu_28x40.yml'
import plaque_alu_40x40 from './yml/plaque_alu_40x40.yml'
import plaque_alu_50x50 from './yml/plaque_alu_50x50.yml'

export default class Ajaxdata {

    constructor(Parent) {
        this.dataParent = Parent;
    }

    getPyml(id_product) {


        // return new Promise(function (resolve, reject) {


        let fileYml;
        switch (id_product) {
            // BOXER
            case '10015':
                fileYml = yml_boxer_homme;
                break;
            case '10016':
                fileYml = yml_boxer_femme;
                break;
            case '10017':
                fileYml = yml_boxer_garcon;
                break;
            case '10018':
                fileYml = yml_boxer_fille;
                break;

            // SHORTY
            case '15038':
                fileYml = yml_shorty_femme;
                break;



            // BRASSIERE
            case '14811':
                fileYml = yml_brassiere_fitness;
                break;

            // TAPIS SOURIS
            case '11311':
                fileYml = yml_tapis_souris_rond;
                break;
            case '10960':
                fileYml = yml_tapis_souris_rectangle;
                break;

            // PLAQUE ALU
            case '11312':
                fileYml = plaque_alu_20x25;
                break;

            case '11313':
                fileYml = plaque_alu_28x40;
                break;

            case '11314':
                fileYml = plaque_alu_40x40;
                break;

            case '11315':
                fileYml = plaque_alu_50x50;
                break;


            // BOULE DE NOEL
            case '13963':
                fileYml = boule_noel_argent;
                break;

            case '13952':
                fileYml = boule_noel_or;
                break;

            case '13964':
                fileYml = boule_noel_multi;
                break;

            case '13965':
                fileYml = boule_noel_rouge;
                break;

            case '13966':
                fileYml = boule_noel_vert;
                break;


            case '15014':
                fileYml = housse_coussin_40x40;
                break;

            case '15015':
                fileYml = housse_coussin_40x60;
                break;

            case '15034':
                fileYml = yml_boxer_long_homme;
                break;

            case '15039':
                fileYml = yml_tourdecou_adulte;
                break;

            case '15106':
                fileYml = yml_tourdecou_enfant;
                break;

            case '15040':
                fileYml = yml_bandana_adulte;
                break;


        }
        // this.dataParent.storage.pyml = fileYml;
        // return this.dataParent.storage.pyml;
        console.log('Load fileYml data IDProduct ' + id_product, fileYml);
        // resolve(fileYml);
        return fileYml;
        // });


    }

    async loadIA() {
        const resLoadingView = await loadingView(
            "chargement_ia",
            "create.svg",
            "Chargement pour génération d'image..",
            null
        );

        const resAjax = await $.ajax({
            type: "GET",
            url: "/modules/personnalisation/action.php",
            dataType: "json",
            data: {
                method: "loadIa",
                id_product: id_product,
            },
            success: function (json) {
                unloadingView('chargement_ia');
            }
        });
        return resAjax;
    };


    async loadAttributes(id_product) {
        // CHARGEMENT DES TAILLES

        const resLoadingView = await loadingView(
            "chargement_attributes",
            "create.svg",
            "Chargement des tailles..",
            null
        );

        const resAjax = await $.ajax({
            type: "GET",
            url: "/modules/personnalisation/action.php",
            dataType: "json",
            data: {
                method: "loadAttributes",
                id_product: id_product,
            },
            success: function (json) {
                unloadingView('chargement_attributes');
            }
        });
        return resAjax;
    };

    async loadData() {
        console.log('Load ajax Datas');
        loadingView(
            "personnalisation_interface",
            "create.svg",
            "Préparation du produit...",
            null
        );

        const result = await $.ajax({
            type: "POST",
            async: false,
            url: prestashop.urls.base_url + "module/personnalisation/ajax",
            dataType: "json",
            data: {
                token: prestashop.static_token,
                verticalOrientation: this.dataParent.storage.verticalOrientation,
                id_product: $("#load-template").attr("data-id_product"),
            },
            success: function (json) {
                //this.dataParent.storage.productData = json.productData;
                var interfaceChoice = "personnalisationfrontdesktop";
                if (this.verticalOrientation === true) {
                    interfaceChoice = "personnalisationfrontmobile";
                }
                //console.log('interfaceChoice:', interfaceChoice)

                if (json.productData.interface.steps.nbstep) {
                    //console.log("ok add nbstep " + json.productData.interface.steps.nbstep);
                    $("#load-template").attr(
                        "data-nbstep",
                        json.productData.interface.steps.nbstep
                    );
                }
                $("#load-template").html(json.html);
                unloadingView('personnalisation_interface');
            },
        });

        return result;
    }


    async loadStickers() {
        console.log('Load ajax Stickers');

        loadingView(
            "personnalisation_stickers",
            "create.svg",
            "Préparation des motifs ...",
            null
        );

        const result = await $.ajax({
            type: "POST",
            url: prestashop.urls.base_url + "modules/personnalisation/action.php",
            dataType: "json",
            data: {
                method: "loadStickers",
                //action: action,
                token: prestashop.static_token,
                id_product: $("#load-template").attr("data-id_product"),
                blockui_img: "create.svg",
                blockui_message: "Chargement des émoticônes...",
                blockui_name: "loadStickers",
            },
            success: function (json) {
                $.each(json.htmlStickers, function (i, info) {
                    //console.log(i);
                    //console.log(info);
                    $("#" + i)
                        .find(".swiper-wrapper")
                        .html(info);
                });

                /*if (typeof callback === "function") {
                    console.log("callback");
                    callback();
                }*/
                unloadingView('personnalisation_stickers');
            },
        });
        return result;

    };
}